import { render, staticRenderFns } from "./HealthWealthSummitOct2021.vue?vue&type=template&id=a4880926&scoped=true"
import script from "./HealthWealthSummitOct2021.vue?vue&type=script&lang=js"
export * from "./HealthWealthSummitOct2021.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4880926",
  null
  
)

export default component.exports